import {Component} from '@angular/core';
import {IonicPage, Platform} from 'ionic-angular';

import {IdCardServerProvider} from '../../providers/idcard-server/idcard-server';

/**
 * Generated class for the IdCardPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-idcard',
  templateUrl: 'idcard.html',
})
export class IdCardPage {

  idCardUrl: string;

  constructor(
    private platform: Platform,
    private idCardServerProvider: IdCardServerProvider
  ) {
    this.idCardUrl = this.idCardServerProvider.fetchMainUrl();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad IdCardPage');
  }

  isMobile() {
    return this.platform.is('cordova');
  }

}



// WEBPACK FOOTER //
// ./src/pages/idcard/idcard.ts